import * as React from "react";
import { AppPageWrapper } from "@talentpair/quantic";

const page = React.lazy(() => import("./SecretAgent"));
const SecretAgent = (): React.ReactElement => <AppPageWrapper page={page} />;
export default SecretAgent;
